const etag = "###[randomUUID]###".split(".");

export function getEtag() {
  return (etag[1] || etag[0])
    .replace("randomUUID", `${Math.floor(Math.random() * 10000000000)}`)
    .replace("###[", "")
    .replace("]###", "");
}
